import { theme } from '@Guidelines/Theme/theme';
import resolveFieldVerificationPresentation from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Helpers/fieldVerificationPresentation';
import type StatusCountView from '@UI/Store/Documents/Views/StatusCountView';
import { css } from '@emotion/react';
import type * as React from 'react';

const trackStyle = css`
	display: flex;
	height: 10px;
	border-radius: ${theme.radii.pill};
	overflow: hidden;
	background-color: ${theme.colors.track};
`;

const segmentStyle = (fill: string, widthPercent: number) => css`
	width: ${widthPercent}%;
	background: ${fill};
`;

type Props = {
	readonly byStatus: readonly StatusCountView[];
	readonly total: number;
};

/**
 * One stacked bar, one segment per verification state, in the server's own fixed order — widths are
 * `count / total`, fills come from the single presentation table (`fieldVerificationPresentation`),
 * `not_addressed` included with its hachured fill.
 */
const VerificationProgressBar: React.FC<Props> = ({ byStatus, total }) => {
	return (
		<div css={trackStyle}>
			{byStatus.map((entry) => {
				const presentation = resolveFieldVerificationPresentation(entry.status.value);
				const widthPercent = total > 0 ? (entry.count / total) * 100 : 0;

				return (
					<div key={entry.status.value} css={segmentStyle(presentation.barFill, widthPercent)} />
				);
			})}
		</div>
	);
};

export default VerificationProgressBar;
